import _classCallCheck from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { getRangeValue, parseAlpha } from "./NumberUtils";
import { hslToRgb, hslaToRgba } from "./ColorUtils";
export var HslColorManager = /*#__PURE__*/function () {
  function HslColorManager() {
    _classCallCheck(this, HslColorManager);

    this.stringPrefix = "hsl";
  }

  _createClass(HslColorManager, [{
    key: "handleColor",
    value: function handleColor(color) {
      var _a;

      var colorValue = color.value,
          hslColor = (_a = colorValue.hsl) !== null && _a !== void 0 ? _a : color.value;

      if (hslColor.h !== undefined && hslColor.l !== undefined) {
        return hslToRgb(hslColor);
      }
    }
  }, {
    key: "handleRangeColor",
    value: function handleRangeColor(color) {
      var _a;

      var colorValue = color.value,
          hslColor = (_a = colorValue.hsl) !== null && _a !== void 0 ? _a : color.value;

      if (hslColor.h !== undefined && hslColor.l !== undefined) {
        return hslToRgb({
          h: getRangeValue(hslColor.h),
          l: getRangeValue(hslColor.l),
          s: getRangeValue(hslColor.s)
        });
      }
    }
  }, {
    key: "parseString",
    value: function parseString(input) {
      if (!input.startsWith("hsl")) {
        return;
      }

      var regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i,
          result = regex.exec(input);
      return result ? hslaToRgba({
        a: result.length > 4 ? parseAlpha(result[5]) : 1,
        h: parseInt(result[1], 10),
        l: parseInt(result[3], 10),
        s: parseInt(result[2], 10)
      }) : undefined;
    }
  }]);

  return HslColorManager;
}();